import { CssVarsProvider, extendTheme } from '@mui/joy';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Landing from "./components/Landing";
import ThankYou from "./components/ThankYou";
import Loom from "./components/Loom";

const theme = extendTheme({
    colorSchemes: {
        light: {
            palette: {
                primary: {
                    50: '#112A74',
                    100: '#112A74',
                    200: '#112A74',
                    300: '#112A74',
                    400: '#112A74',
                    500: '#112A74',
                    600: '#112A74',
                    700: '#112A74',
                    800: '#112A74',
                    900: '#112A74',
                },
            },
        },
    },
});

function App() {
    return (
        <CssVarsProvider theme={theme}>
            <Router>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/thank-you" element={<ThankYou />} />
                    <Route path="/loom" element={<Loom />} />
                </Routes>
            </Router>
        </CssVarsProvider>
    );
}

export default App;
